import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type ListScreen =
    Extract<Screen, { type: "list" }>;

export class ListScreenMapper
    implements ScreenMapper<ListScreen> {

    public readonly type = "list" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: ListScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "list",

                from:
                    state.primaryScreen

            },

            completedProducts:
                screen.products ?? [],

            isListLoading: false,

            isLoading: false

        });

    }

}